import { useSortable } from '@dnd-kit/sortable';
import { useMemo } from 'react';
import { Item } from '../Item';
import { ItemPropsI } from '../types';

/**
 * SortableItem.
 */
export const SortableItem = (props: ItemPropsI) => {
  const id = useMemo(() => props.value, [props.value]);
  const { setNodeRef, listeners, isDragging, transform, transition } =
    useSortable({
      id: id as any, // FIXME: any
    });

  return (
    <Item
      as="span"
      ref={setNodeRef}
      dragging={isDragging}
      transition={transition}
      transform={transform}
      listeners={listeners}
      {...props}
    />
  );
};
